import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './index.css'
import App from './App.tsx'

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

const rootEl = document.getElementById('root')!

if (rootEl.hasChildNodes()) {
  // Prerendered HTML present (production build): hydrate it.
  hydrateRoot(rootEl, app)
} else {
  // Dev server / empty shell: render fresh.
  createRoot(rootEl).render(app)
}
